module.exports = __webpack_public_path__ + "static/media/banner-3.9842becc.jpeg";